export const isNumber = (str) => {
    if (typeof str === 'number') {
        return true;
    }
    if (typeof str === 'boolean') {
        return false; // Number(true) === 1, would incorrectly return true
    }
    return !!str && `${str}`.trim() !== '' && !isNaN(Number(str));
};
/*
  Rounding
*/
export const roundToSigDigits = (n, sigDigits = 1) => parseFloat(n.toPrecision(sigDigits));
export const roundToDecimals = (n, decimals) => Math.round(n * Math.pow(10, decimals)) / Math.pow(10, decimals);
export const roundAndTruncate = (n, sigDigits = 1) => {
    const rounded = roundToSigDigits(n, sigDigits);
    if (rounded >= 1e12) {
        return `${roundToSigDigits(rounded / 1e12, sigDigits)}T`;
    }
    if (rounded >= 1e9) {
        return `${roundToSigDigits(rounded / 1e9, sigDigits)}B`;
    }
    if (rounded >= 1e6) {
        return `${roundToSigDigits(rounded / 1e6, sigDigits)}M`;
    }
    if (rounded >= 1e3) {
        return `${roundToSigDigits(rounded / 1e3, sigDigits)}k`;
    }
    return rounded.toString();
};
export const rainfallRounding = (value) => {
    if (value === undefined)
        return {
            value: 0,
            abbreviation: ''
        };
    let decimalPlaces;
    let divisor = 1;
    let multiplier = 1;
    let abbreviation = '';
    if (value < 1) {
        // < 1: Round to nearest .1
        decimalPlaces = 1;
    }
    else if (value < 10) {
        // >= 1 and < 10: Round to nearest 1
        decimalPlaces = 0;
    }
    else if (value < 1e3) {
        // >= 10 and < 1,000: Round to nearest 10
        decimalPlaces = 0;
        divisor = 10;
        multiplier = 10;
    }
    else if (value < 1e6) {
        // >= 1,000 and < 1,000,000: Round to nearest 1,000 (e.g. “134k”)
        decimalPlaces = 0;
        divisor = 1e3;
        abbreviation = 'k';
    }
    else {
        // >= 1,000,000 and < 1,000,000,000: Round to nearest 100,000 and use decimal (e.g. “3.4M”)
        decimalPlaces = 1;
        divisor = 1e6;
        abbreviation = 'M';
    }
    value = value / divisor;
    const factor = Math.pow(10, decimalPlaces);
    const roundedValue = (Math.round(value * factor) / factor) * multiplier;
    return {
        value: roundedValue,
        abbreviation: abbreviation
    };
};
/*
  Number -> String formatting
*/
export const getUnitsStr = (n, singularUnit, pluralUnit) => {
    if (!isNumber(n)) {
        // default to singular unit if provided a string value
        return singularUnit;
    }
    if (n === 1 || n === -1) {
        return singularUnit;
    }
    else {
        return pluralUnit;
    }
};
export const getOrdinalNumberStr = (n) => {
    if (n !== undefined) {
        const value = n > 1 ? Math.round(n) : 1;
        const modTen = value % 10;
        const modHundred = value % 100;
        if (modTen === 1 && modHundred !== 11) {
            return `${value}st`;
        }
        if (modTen === 2 && modHundred !== 12) {
            return `${value}nd`;
        }
        if (modTen === 3 && modHundred !== 13) {
            return `${value}rd`;
        }
        return `${value}th`;
    }
    return undefined;
};
export const percentageToString = (n) => {
    if (n > 0 && n < 1) {
        return '<1%';
    }
    return `${Math.round(n)}%`;
};
export const formatDollarAmount = (value) => {
    const result = roundAndTruncate(value ?? 0, 2);
    // Parse the result to a number
    const num = parseFloat(result);
    // If the result is exactly zero, return "0.00", otherwise return the original result
    return num === 0 ? '0.00' : result;
};
//# sourceMappingURL=numbers.js.map